import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SectionDivider } from '../components/Layout';

export default function AboutPage() {
  const [achievements, setAchievements] = useState([]);
  const [expandedMessage, setExpandedMessage] = useState(null);
  const [expandedPhilosophy, setExpandedPhilosophy] = useState(null);

  // 理念の詳細表示切り替え
  const togglePhilosophy = (philosophyType) => {
    setExpandedPhilosophy(expandedPhilosophy === philosophyType ? null : philosophyType);
  };

  // メッセージの詳細表示切り替え
  const toggleMessage = (messageType) => {
    setExpandedMessage(expandedMessage === messageType ? null : messageType);
  };

  // タイトルの内容によって背景画像を決定
  const getBackgroundImage = (title) => {
    if (title.includes('1位') || title.includes('第1位') || title.includes('１位') || title.includes('第１位')) {
      return '/images/about/jusho1.jpg';
    } else if (title.includes('2位') || title.includes('第2位') || title.includes('２位') || title.includes('第２位')) {
      return '/images/about/jusho2.jpg';
    } else if (title.includes('3位') || title.includes('第3位') || title.includes('３位') || title.includes('第３位')) {
      return '/images/about/jusho3.jpg';
    } else {
      return '/images/about/jusho4.jpg';
    }
  };

  // microCMSから実績データを取得
  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const response = await fetch(
          `https://${process.env.REACT_APP_MICROCMS_SERVICE_DOMAIN}.microcms.io/api/v1/news?filters=display_location[contains]農園についてページ&limit=2&orders=-date`,
          {
            headers: {
              'X-MICROCMS-API-KEY': process.env.REACT_APP_MICROCMS_API_KEY,
            },
          }
        );
        const data = await response.json();
        
        if (data.contents) {
          setAchievements(data.contents);
        }
      } catch (error) {
        console.log('実績データを取得できませんでした');
      }
    };

    fetchAchievements();
  }, []);

  return (
    <div className="min-h-screen relative">
      
      {/* ヒーローセクション */}
      <section 
        className="h-80 md:h-screen flex items-end justify-center md:items-start md:justify-start relative pt-8 md:pt-16 px-4 md:pl-48"
        style={{
          width: '100vw',
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/about/team_photo_mobile.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden'
        }}
      >
        {/* PCバージョン背景画像 */}
        <div 
          className="hidden md:block absolute inset-0 z-0"
          style={{
            backgroundImage: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/about/team_photo_desktop.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        <div style={{
          position: 'relative', 
          zIndex: 2
        }} className="text-center md:text-left">
          <h1 className="font-bold text-white leading-tight" style={{
            fontSize: window.innerWidth >= 768 ? '56px' : '24px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
          }}>
            <span style={{color: '#fed7aa'}}>科学</span>と<span style={{color: '#fed7aa'}}>温かさ</span>で<br />
            未来を育む
          </h1>
        </div>
      </section>

      {/* SVG区切り1: ヒーロー → 基本情報 */}
      <SectionDivider title="information" />

      {/* コンテンツエリア：IndexPage.jsと同じ構造 */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 農園基本情報セクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">

              {/* 農園基本データタイトル */}
              <h3 className="heading-2 mb-6 text-center" style={{color: '#8b4513'}}>農園<span style={{color: '#ff8c00'}}>基本</span>情報</h3>

              {/* カード1：農園基本データ */}
              <div className="mb-8">
                <div className="rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200" style={{backgroundColor: '#ffedcfff'}}>
                  <div className="responsive-grid-2 items-center gap-6 md:gap-8">
                    
                    {/* 左列：写真のみ */}
                    <div className="text-center order-1 md:order-1">
                      <div className="flex justify-center">
                        <div className="w-40 h-40 md:w-56 md:h-56 rounded-full overflow-hidden shadow-lg">
                          <img 
                            src="/images/about/overview.jpg" 
                            alt="立石農園の様子" 
                            className="w-full h-full object-cover object-center"
                            style={{transform: 'scale(1.4)'}}
                          />
                        </div>
                      </div>
                    </div>

                    {/* 右列：基本データ */}
                    <div className="text-center md:text-left order-2 md:order-2">
                      <div className="space-y-3 text-sm md:text-base" style={{color: '#8b4513', opacity: 0.8}}>
                        <div>
                          <span className="font-medium" style={{color: '#8b4513'}}>農園名：</span>
                          <span>立石農園</span>
                        </div>
                        <div>
                          <span className="font-medium" style={{color: '#8b4513'}}>代表者：</span>
                          <span>立石瑛人</span>
                        </div>
                        <div>
                          <span className="font-medium" style={{color: '#8b4513'}}>所在地：</span>
                          <span>〒849-4274<br />佐賀県伊万里市東山代町脇野4980-3</span>
                        </div>
                        <div>
                          <span className="font-medium" style={{color: '#8b4513'}}>電話：</span>
                          <span>080-8374-1575</span>
                        </div>
                        <div>
                          <span className="font-medium" style={{color: '#8b4513'}}>チーム：</span>
                          <span>正社員3名、パート6名（20代中心）</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 主な農作物タイトル */}
              <h3 className="heading-2 mb-6 text-center" style={{color: '#8b4513'}}><span style={{color: '#ff8c00'}}>主な</span>農作物</h3>

              <div className="responsive-grid-2">
                {/* カード2：きゅうり */}
                <div className="rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 text-center" style={{backgroundColor: '#ffedcfff'}}>
                  <div className="flex justify-center mb-4">
                    <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden shadow-lg">
                      <img 
                        src="/images/about/crops1.jpg" 
                        alt="きゅうり" 
                        className="w-full h-full object-cover object-center"
                        style={{transform: 'scale(1.4)'}}
                      />
                    </div>
                  </div>
                  <h4 className="heading-3 mb-3" style={{color: '#8b4513'}}>
                    きゅうり
                  </h4>
                  <div className="space-y-2 caption-text" style={{color: '#8b4513', opacity: 0.8}}>
                    <p>• 年間150トン生産、栽培面積43a</p>
                    <p>• オランダ式高軒高ハウス + 溶液栽培</p>
                    <p>• 科学的データ管理により1年中収穫可能</p>
                  </div>
                </div>

                {/* カード3：さつまいも */}
                <div className="rounded-xl md:rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 text-center" style={{backgroundColor: '#ffedcfff'}}>
                  <div className="flex justify-center mb-4">
                    <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden shadow-lg">
                      <img 
                        src="/images/about/crops2.jpg" 
                        alt="さつまいも" 
                        className="w-full h-full object-cover object-center"
                        style={{transform: 'scale(1.4)'}}
                      />
                    </div>
                  </div>
                  <h4 className="heading-3 mb-3" style={{color: '#8b4513'}}>
                    さつまいも（紅はるか）
                  </h4>
                  <div className="space-y-2 caption-text" style={{color: '#8b4513', opacity: 0.8}}>
                    <p>• 年間10トン生産、栽培面積50a</p>
                    <p>• 露地栽培、自作堆肥で土作り</p>
                    <p>• 循環型農業で持続可能な栽培を実践</p>
                  </div>
                </div>
              </div>

              {/* 詳細はこちらボタン */}
              <div className="text-center mt-8">
                <Link 
                  to="/products"
                  className="inline-block text-white px-6 py-3 rounded-lg font-bold transition-colors text-base hover:opacity-90"
                  style={{backgroundColor: '#8b4513'}}
                >
                  詳細はこちら
                </Link>
              </div>

            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り2: 基本情報 → 立石農園の想いと理念 */}
      <SectionDivider title="philosophy" />

      {/* コンテンツエリア：IndexPage.jsと同じ構造 */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">
        
          {/* 立石農園の想いと理念セクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="space-y-6">
                
                {/* 理念1：科学的農業の追求 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  {/* 理念1イラストデータ */}
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img 
                      src="/images/about/rinen1.svg" 
                      alt="科学的農業の追求" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>オランダ式ハウス×データ管理で最適な環境を実現</h3>
                  <button
                    onClick={() => togglePhilosophy('science')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedPhilosophy === 'science' ? '詳細を閉じる' : '詳細を見る'}
                  </button>
                  
                  {/* 理念1詳細メッセージ */}
                  {expandedPhilosophy === 'science' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>データと技術で、確かな品質を。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          私たちは、<strong>科学的データ管理と最新技術</strong>を駆使して、作物の品質向上と生産性向上に取り組んでいます。
                        </p>
                        <p>
                          病気予防、水分管理、養分供給など、すべてをデータで可視化し、最適な栽培環境を維持することで、<strong>安定した高品質な農産物の供給</strong>を実現しています。
                        </p>
                        <p>
                          伝統的な農業の知恵と現代の科学技術を融合させ、効率的で持続可能な農業を追求し続けます。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* 理念2：地域価値の創造 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  {/* 理念2イラストデータ */}
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img 
                      src="/images/about/rinen2.svg" 
                      alt="地域価値の創造" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>20代中心チームで失敗も成功もみんなで共有し成長</h3>

                  <button
                    onClick={() => togglePhilosophy('regional')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedPhilosophy === 'regional' ? '詳細を閉じる' : '詳細を見る'}
                  </button>
                  
                  {/* 理念2詳細メッセージ */}
                  {expandedPhilosophy === 'regional' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>仲間と共に、未来を育てる。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          中山間地域の豊かな自然環境と地域資源を最大限に活用し、<strong>地域に根ざした新しい価値</strong>を創造しています。
                        </p>
                        <p>
                          自作堆肥づくりや循環型農業の実践を通じて、<strong>持続可能で環境に優しい農業</strong>を展開し、次世代に美しい自然環境を残していきます。
                        </p>
                        <p>
                          地域の文化や伝統を大切にしながら、革新的な取り組みで地域農業の可能性を広げていきます。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* 理念3：チーム成長 */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  {/* 理念3イラストデータ */}
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img 
                      src="/images/about/rinen3.svg" 
                      alt="チーム成長" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>中山間地域で自作堆肥による持続可能農業を実践</h3>
                  <button
                    onClick={() => togglePhilosophy('team')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedPhilosophy === 'team' ? '詳細を閉じる' : '詳細を見る'}
                  </button>
                  
                  {/* 理念3詳細メッセージ */}
                  {expandedPhilosophy === 'team' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>地域の恵みを活かし、循環する農業を。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          私たちは20代中心の若いチームで、<strong>お互いを思いやり、支え合いながら</strong>日々の農業に取り組んでいます。
                        </p>
                        <p>
                          一人一人の個性や強みを活かし、<strong>チーム全体で学び成長</strong>することを大切にしています。失敗を恐れず挑戦し、共に経験を積み重ねています。
                        </p>
                        <p>
                          農業を通じて、人としても成長し、地域農業の未来を担う次世代のリーダーを目指しています。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り3: 理念・メッセージ → メッセージ個別カード */}
      <SectionDivider title="messages" />

      {/* コンテンツエリア：IndexPage.jsと同じ構造 */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-5xl mx-auto">
        
          {/* 立石農園からのメッセージセクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">

              <div className="space-y-6">
                
                {/* お客様へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  <h3 className="text-base md:text-lg font-bold mb-1 md:mb-2" style={{color: '#8b4513'}}>お客様へ</h3>
                  
                  {/* お客様向けイラレデータ */}
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img 
                      src="/images/about/messages1.svg" 
                      alt="お客様向けメッセージ" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <p className="caption-text leading-relaxed mb-4" style={{color: '#8b4513', opacity: 0.8}}>
                    毎日の食卓に、安心と笑顔をお届けします。<br />安全で美味しい農作物を通じて、ご家族の健康と幸せをサポートいたします。
                  </p>
                  <button
                    onClick={() => toggleMessage('customer')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedMessage === 'customer' ? 'メッセージを閉じる' : 'メッセージを詳しく見る'}
                  </button>
                  
                  {/* お客様向け詳細メッセージ */}
                  {expandedMessage === 'customer' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>毎日の食卓に、安心と笑顔を。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          私たちは、<strong>安心して食べられる美味しい農作物を安定的にお届けすること</strong>を何より大切にしています。
                        </p>
                        <p>
                          最新のデータ管理や技術を活用しながらも、地域の自然や文化、人々とのつながりを守り続ける——そんな<strong>持続可能（サステナブル）な農業</strong>を実践しています。
                        </p>
                        <p>
                          小さなお子様からご年配の方まで、毎日の食卓が笑顔で満たされるよう、ひとつひとつの作物に心を込めて育てています。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* 事業所様へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>事業所様へ</h3>
                  
                  {/* 事業所様向けイラレデータ */}
                  <div className="w-full h-20 md:h-40 mb-0 rounded-lg">
                    <img 
                      src="/images/about/messages2.svg" 
                      alt="事業所様向けメッセージ" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <p className="caption-text leading-relaxed mb-4" style={{color: '#8b4513', opacity: 0.8}}>
                    安定した品質と持続可能な供給で、信頼関係を築きます。<br />
                      科学的農業と効率的な生産体制で、お取引先のニーズにお応えします。
                  </p>
                  <button
                    onClick={() => toggleMessage('business')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedMessage === 'business' ? 'メッセージを閉じる' : 'メッセージを詳しく見る'}
                  </button>
                  
                  {/* 事業所向け詳細メッセージ */}
                  {expandedMessage === 'business' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>安定した品質と持続可能な供給で、信頼を。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          私たちは20代中心のチームで、農業の未来を切り開こうとしています。祖父の代から受け継がれた想いに加え、科学的データ管理や環境センサーなどの技術を導入し、<strong>品質の安定と効率的な生産</strong>を実現しています。
                        </p>
                        <p>
                          さらに、地域の自然や文化を守りながら、<strong>持続可能（サステナブル）な農業の実践</strong>にも取り組んでいます。
                        </p>
                        <p>
                          これからも、<strong>安定的な出荷体制と柔軟な対応力</strong>で、お取引先の皆様に長く信頼される存在を目指します。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* 地域の方々へ */}
                <div className="bg-gradient-to-br from-orange-50 to-yellow-100 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border" style={{borderColor: '#d2b48c'}}>
                  
                  <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3" style={{color: '#8b4513'}}>地域の方々へ</h3>
                  
                  {/* 地域の方々向けイラレデータ */}
                  <div className="w-full h-20 md:h-28 mb-1 rounded-lg overflow-hidden">
                    <img 
                      src="/images/about/messages3.svg" 
                      alt="地域の方々向けメッセージ" 
                      className="mx-auto object-cover"
                      style={{width: '80%', height: '80%'}}
                    />
                  </div>
                  
                  <p className="caption-text leading-relaxed mb-4" style={{color: '#8b4513', opacity: 0.8}}>
                    地域とともに、未来を育てます。<br />地域の自然や文化を大切にしながら、次世代に誇れる農業を築いてまいります。
                  </p>
                  <button
                    onClick={() => toggleMessage('local')}
                    className="text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm"
                    style={{backgroundColor: '#8b4513'}}
                  >
                    {expandedMessage === 'local' ? 'メッセージを閉じる' : 'メッセージを詳しく見る'}
                  </button>
                  
                  {/* 地域向け詳細メッセージ */}
                  {expandedMessage === 'local' && (
                    <div className="mt-4 p-4 rounded-lg border text-center" style={{backgroundColor: '#ffedcfff', borderColor: '#d2b48c'}}>
                      <h4 className="font-bold text-lg mb-3" style={{color: '#8b4513'}}>地域とともに、未来を育てる。</h4>
                      <div className="space-y-3 text-sm" style={{color: '#8b4513'}}>
                        <p>
                          農業は作物を育てるだけでなく、人や地域、そして自然を育む営みです。私たちは、地域の皆様とのつながりを大切にしながら、<strong>山や水、大地に根づいた環境や文化を守りつつ、持続可能（サステナブル）な農業</strong>を実践しています。
                        </p>
                        <p>
                          農業を志す若者が挑戦できる環境を整え、次の世代へと誇れる農業を残すことが、私たちの使命です。
                        </p>
                        <p>
                          これからも地域と共に歩み、<strong>安心できる食と未来</strong>を築いてまいります。
                        </p>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り3: メッセージ → 代表者紹介 */}
      <SectionDivider title="representative" />

      {/* コンテンツエリア：IndexPage.jsと同じ構造 */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

{/* 代表者紹介セクション */}
<section className="tateishi-section">
  <div className="-mx-4 md:px-6">

    <div className="responsive-grid-2 items-center gap-6 md:gap-8">
      
      {/* 左列：写真のみ */}
      <div className="text-center order-1 md:order-1">
        <div className="flex justify-center">
          <div className="w-40 h-40 md:w-56 md:h-56 rounded-full overflow-hidden shadow-lg">
            <img 
              src="/images/about/eito.jpg" 
              alt="代表者 立石瑛人" 
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>

      {/* 右列：代表 + 名前 + 所属団体 */}
      <div className="text-center md:text-left order-2 md:order-2">
        {/* 代表・名前 */}
        <div className="mb-6">
          <p className="heading-3 mb-2" style={{color: '#8b4513'}}>代表</p>
          <h3 className="heading-3" style={{color: '#8b4513', opacity: 0.8}}>立石 瑛人(たていし えいと)</h3>
        </div>
        
        {/* 所属団体 */}
        <div>
          <h5 className="heading-3 mb-2" style={{color: '#8b4513'}}>所属団体</h5>
          <div className="space-y-2 body-text" style={{color: '#8b4513', opacity: 0.8}}>
            <p>佐賀県農業青年倶楽部連絡協議会（4Hクラブ）</p>
            <p>JA伊万里青年部、JA伊万里きゅうり部会</p>
            <p>中小企業家同友会、伊万里商工会議所</p>
          </div>
        </div>
      </div>
    </div>

    {/* 代表挨拶（全幅） */}
    <div className="rounded-xl md:rounded-2xl shadow-md p-6 md:p-8 mt-6 md:mt-8 border border-stone-100" style={{backgroundColor: '#fffbe0'}}>
      <h3 className="heading-2 mb-4 md:mb-6 text-center" style={{color: '#8b4513'}}>
        代表挨拶<br />
        ～農業への想い～
      </h3>
      <div className="space-y-6 md:space-y-8 body-text text-left max-w-5xl mx-auto px-4 md:px-0" style={{color: '#8b4513'}}>
        
        <div className="text-center mb-6">
          <p className="text-lg md:text-xl" style={{color: '#8b4513'}}>若い力で、地域農業の未来を切り開く。</p>
        </div>

        {/* 農業を志したきっかけ */}
        <div className="text-center">
          <h4 className="heading-3 mb-3 md:mb-4" style={{color: '#8b4513'}}>農業を志したきっかけ</h4>
          <div className="space-y-3 md:space-y-4 text-center md:text-left leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
            <p>私が農業の道を志すきっかけとなったのは、幼い頃に見た<strong>祖父のきゅうり栽培</strong>でした。畑で汗を流す姿や、収穫の喜びを共に味わった記憶が、今も鮮明に心に残っています。</p>
            <p>地域を見渡すと、農業の担い手はどんどん減っていき、高齢化が進んでいます。「誰かがやらなければ」、「自分がなんとかしたい」という強い使命感は、祖父の思い出と重なり合い、私の中で大きな原動力となりました。</p>
          </div>
        </div>

        {/* これからの時代に合った農業へ */}
        <div className="text-center">
          <h4 className="heading-3 mb-3 md:mb-4" style={{color: '#8b4513'}}>これからの時代に合った農業へ</h4>
          <div className="space-y-3 md:space-y-4 text-center md:text-left leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
            <p>若い力で農業界を変えていこうと決意し、<strong>これからの時代に求められる新しい農業</strong>に挑戦しています。科学的データ管理や最新技術を取り入れながらも、<strong>地域の人々や自然、山や水、大地に根づいてきた文化や暮らし——取り巻く環境の良いものは守り続け、持続可能（サステナブル）な農業を実現する</strong>。それが、私たちの農業のかたちです。</p>
            <p>実際に農業をはじめ、地域の方々とのつながりを深める中で、「自分たちが引っ張っていかなければ」という想いはいっそう強まりました。農業は作物を育てるだけでなく、人と地域を育む営みであることを日々実感しています。</p>
          </div>
        </div>

        {/* つながりを大切に、未来を築く */}
        <div className="text-center">
          <h4 className="heading-3 mb-3 md:mb-4" style={{color: '#8b4513'}}>つながりを大切に、未来を築く</h4>
          <div className="space-y-3 md:space-y-4 text-center md:text-left leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
            <p>私たちは、地域の皆様に<strong>安全で美味しい農作物を安定的にお届けすること</strong>を約束します。また、農業を志す若者にとって働きやすく、誇りを持てる環境を整え、<strong>次世代の育成と地域の活性化</strong>にも力を注いでいます。</p>
            <p>20代中心のチームで、「農作物にも働く人間にも優しい環境」を築き、地域農業の未来を切り開いています。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        </div>
      </div>

      {/* SVG区切り4: 代表者紹介 → 若手メンバー紹介 */}
      <SectionDivider title="team" />

      {/* コンテンツエリア：IndexPage.jsと同じ構造 */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 若手メンバー紹介セクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">

              <div className="text-center mb-8 md:mb-12">
                <h2 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  若手メンバー紹介
                </h2>
                <p className="heading-3" style={{color: '#8b4513', opacity: 0.8}}>
                  20代中心のチームで農業の未来を切り開きます
                </p>
              </div>

              <div className="responsive-grid-3">
                {/* メンバー1：松尾優也 */}
                <div className="rounded-xl md:rounded-2xl p-4 md:p-6 text-center" style={{backgroundColor: '#ffedcfff'}}>

                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 md:w-32 md:h-32 rounded-full overflow-hidden shadow-lg">
                      <img 
  src="/images/about/matsuo.jpg" 
  alt="松尾優也" 
  className="w-full h-full object-cover object-center"
  style={{transform: 'scale(1.0)',}}
/>
                    </div>
                  </div>
                  <h3 className="heading-3 mb-2" style={{color: '#8b4513'}}>松尾優也</h3>
                  <p className="caption-text mb-3" style={{color: '#8b4513', opacity: 0.7}}>全体統括<br />養液栽培ハウス担当</p>
                  <div className="caption-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    <p>「仕事も趣味も全力で！」</p>
                  </div>
                </div>

                {/* メンバー2：山口乃碩 */}
                <div className="rounded-xl md:rounded-2xl p-4 md:p-6 text-center" style={{backgroundColor: '#ffedcfff'}}>
                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 md:w-32 md:h-32 rounded-full overflow-hidden shadow-lg">
                      <img 
                        src="/images/about/yamaguchi.jpg" 
                        alt="山口乃碩" 
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </div>
                  <h3 className="heading-3 mb-2" style={{color: '#8b4513'}}>山口乃碩</h3>
                  <p className="caption-text mb-3" style={{color: '#8b4513', opacity: 0.7}}>パワー系、力仕事<br />土耕ハウス担当</p>
                  <div className="caption-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    <p>「頼れるプーさんです！」</p>
                  </div>
                </div>

                {/* メンバー3：近藤謙晋 */}
                <div className="rounded-xl md:rounded-2xl p-4 md:p-6 text-center" style={{backgroundColor: '#ffedcfff'}}>
                  <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 md:w-32 md:h-32 rounded-full overflow-hidden shadow-lg">
                      <img 
                        src="/images/about/kondo.jpg" 
                        alt="近藤謙晋" 
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                  </div>
                  <h3 className="heading-3 mb-2" style={{color: '#8b4513'}}>近藤謙晋</h3>
                  <p className="caption-text mb-3" style={{color: '#8b4513', opacity: 0.7}}>ムードメーカー<br />サツマイモ担当</p>
                  <div className="caption-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                    <p>「女子社員募集中！」</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り5: 若手メンバー紹介 → 実績・受賞歴 */}
      <SectionDivider title="awards" />

      {/* コンテンツエリア：実績・受賞歴のみ画面幅いっぱい */}
      <div className="tateishi-content ml-0 md:ml-40">
        <div className="w-full px-4 md:px-6">

          {/* 実績・受賞歴セクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  実績・受賞歴
                </h2>
                <p className="heading-3" style={{color: '#8b4513', opacity: 0.8}}>
                  科学的農業の成果が認められ、数々の受賞をいただいています
                </p>
              </div>
              
              {achievements.length > 0 ? (
                <div className="flex flex-wrap justify-center gap-6">
                  {achievements.map((achievement, index) => {
                    const date = new Date(achievement.date);
                    const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月`;
                    
                    // 背景画像を決定
                    const backgroundImage = getBackgroundImage(achievement.title);
                    
                    return (
                      <div 
                        key={achievement.id} 
                        className="relative text-center"
                        style={{
                          width: window.innerWidth >= 768 ? '400px' : '200px',
                          height: window.innerWidth >= 768 ? '200px' : '100px',
                          borderRadius: '12px',
                          backgroundImage: `url(${backgroundImage})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat'
                        }}
                      >
                        <div className="p-4 flex flex-col justify-center h-full text-center">
                          <p className="caption-text mb-2" style={{color: '#8b4513'}}>{formattedDate}</p>
                          <h4 className="text-sm md:heading-3" style={{color: '#8b4513'}}>{achievement.title}</h4>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex justify-center">
                  <div 
                    className="flex items-center justify-center"
                    style={{
                      width: window.innerWidth >= 768 ? '400px' : '360px',
                      height: window.innerWidth >= 768 ? '200px' : '180px',
                      borderRadius: '12px',
                      backgroundColor: '#f3f4f6',
                      border: '2px dashed #d1d5db'
                    }}
                  >
                    <div className="text-center">
                      <p className="heading-3 mb-2" style={{color: '#8b4513'}}>実績データを読み込めませんでした</p>
                      <p className="caption-text" style={{color: '#8b4513', opacity: 0.6}}>しばらくしてから再度お試しください</p>
                    </div>
                  </div>
                </div>
              )}

              {/* 詳細はこちらボタン */}
              <div className="text-center mt-8">
                <Link 
                  to="/news"
                  className="inline-block text-white px-6 py-3 rounded-lg font-bold transition-colors text-base hover:opacity-90"
                  style={{backgroundColor: '#8b4513'}}
                >
                  詳細はこちら
                </Link>
              </div>

            </div>
          </section>

        </div>
      </div>

    </div>
  );
}